var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestNg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "contents",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:red;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, "\u30A2\u30FC\u30C8\u30DC\u30FC\u30C9 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 75,
    height: 75,
    rx: 11.338583,
    id: "rect8",
    x: 0,
    y: 0,
    ry: 11.338583,
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211714",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.33333
    },
    d: "m 47.82648,39.84877 -0.0258,0.0385 c -0.76234,1.14359 -2.17489,1.74782 -4.08498,1.74782 -3.32072,0 -5.3835,-2.02105 -5.3835,-5.2744 0,-3.12536 2.04496,-5.22524 5.08854,-5.22524 1.96574,0 3.4874,0.69041 4.17489,1.89407 l 0.0858,0.1503 -2.1971,0.91776 -0.0847,-0.0811 c -0.446,-0.42784 -1.03756,-0.65392 -1.7108,-0.65392 -1.51426,0 -2.4926,1.1768 -2.4926,2.99813 0,1.8525 1.01233,3.09697 2.51946,3.09697 0.80318,0 1.57484,-0.25396 1.84869,-0.60652 V 37.50808 H 43.0874 v -1.97619 h 4.73904 z M 36.2267,41.62347 H 33.49424 L 29.9353,35.77093 v 5.85254 H 27.17352 V 31.14714 h 2.73273 l 3.55893,5.85254 v -5.85254 h 2.76152 z m 13.52384,5.73747 C 54.46518,44.82081 57.5,40.84941 57.5,36.3853 57.5,28.71675 48.54577,22.5 37.5,22.5 c -11.04578,0 -20,6.21675 -20,13.8853 0,7.6688 8.95422,13.88531 20,13.88531 1.68969,0 3.33004,-0.146 4.89747,-0.41998 2.13487,1.65354 4.88597,2.64937 7.88898,2.64937 1.73219,0 3.38021,-0.33203 4.875,-0.92942 -2.21847,-0.8871 -4.09813,-2.36094 -5.41091,-4.20964",
    id: "path836"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestNg);
export default __webpack_public_path__ + "static/media/TestNg.ce054c7d1e85c206723c28aee69e9691.svg";
export { ForwardRef as ReactComponent };